import { takeLatest, put } from 'redux-saga/effects';
import { UserAPI } from 'api/user';
import { added } from 'stores/users';
import { createMember } from '../actions';
import { addUser, setMembersLoading } from '../slice';
function* createMemberSaga(action) {
    const { payload } = action;
    const { data, successCallback, failureCallback } = payload;
    try {
        yield put(setMembersLoading(true));
        const user = yield UserAPI.createUser(data);
        yield put(addUser(user));
        yield put(added(user));
        if (successCallback) {
            successCallback(user);
        }
    } catch (error) {
        if (failureCallback) {
            failureCallback(error);
        }
    } finally{
        yield put(setMembersLoading(false));
    }
}
export const watchCreateMemberSaga = function*() {
    yield takeLatest(createMember.type, createMemberSaga);
};
